<template>
    <div class="content-services-container">
        <CommonComponentsTopicSection type="ContentServices" />
        <div class="global-limited-1360px-container">
            <CommonComponentsSupportContentServicesTexts />
            <CommonComponentsSupportContentServicesInfo />
        </div>
    </div>
</template>

<style lang="less" scoped>
    .content-services-container {
        background-color: #000000;
        color: #ffffff;
    }
</style>
